import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _JSXStyle from "styled-jsx/style";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useRouter } from 'next/router';
import { toInt, omit, isObject } from '@cullylarson/f';
import Link from 'next/link';
import { paramUrl } from '@@client/lib/url';
import { getPagesToRender } from '@@client/lib/pagination';
export default function Pagination(_ref) {
  var page = _ref.page,
      totalItems = _ref.totalItems,
      perPage = _ref.perPage,
      pageQueryParamName = _ref.pageQueryParamName;
  page = toInt(1, page);
  totalItems = toInt(0, totalItems);
  perPage = toInt(20, perPage);
  var router = useRouter();
  var totalPages = !perPage ? 0 : Math.ceil(totalItems / perPage);
  if (totalPages < 1) totalPages = 1;
  if (page > totalPages) page = totalPages;
  if (page < 1) page = 1;
  if (totalPages === 1) return '';
  var havePrev = page > 1;
  var haveNext = page < totalPages && totalPages > 1;
  var pagesToRender = getPagesToRender(page, totalPages, 1, 1, 1);

  var renderLink = function renderLink(p, title) {
    var getUrl = function getUrl() {
      // if page one, don't include the parame
      if (p === 1) {
        return paramUrl(router.pathname, omit([pageQueryParamName], router.query));
      } else {
        return paramUrl(router.pathname, _objectSpread(_objectSpread({}, router.query), {}, _defineProperty({}, pageQueryParamName, p)));
      }
    };

    var url = getUrl();
    return /*#__PURE__*/_jsx(Link, {
      href: url,
      children: /*#__PURE__*/_jsx("a", {
        "aria-label": "Got to page ".concat(p, " of results"),
        children: title
      })
    });
  };

  var renderOne = function renderOne(p, title) {
    if (isObject(p)) {
      return /*#__PURE__*/_jsx("li", {
        className: "ellipsis",
        children: "..."
      }, p.key);
    } else {
      if (!title) title = p;
      var isCurrent = p === page;
      var className = isCurrent ? 'is-current' : '';
      return /*#__PURE__*/_jsx("li", {
        className: className,
        children: renderLink(p, title)
      }, p);
    }
  };

  var renderPrev = function renderPrev() {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (!havePrev) return null;
    var prevPage = havePrev ? page - 1 : page;
    return /*#__PURE__*/_jsx("li", {
      children: renderLink(prevPage, /*#__PURE__*/_jsxs("span", {
        children: ["\xAB ", title]
      }))
    }, 'prev');
  };

  var renderNext = function renderNext(title) {
    if (!haveNext) return null;
    var nextPage = haveNext ? page + 1 : page;
    return /*#__PURE__*/_jsx("li", {
      children: renderLink(nextPage, /*#__PURE__*/_jsxs("span", {
        children: [title, " \xBB"]
      }))
    }, 'next');
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-1685798257" + " " + 'pagination-numbers',
      children: [/*#__PURE__*/_jsx("p", {
        className: "jsx-1685798257",
        children: "View page:"
      }), /*#__PURE__*/_jsxs("ul", {
        className: "jsx-1685798257",
        children: [renderPrev(), pagesToRender.map(function (p) {
          return renderOne(p);
        }), renderNext()]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "jsx-1685798257" + " " + 'pagination-next-prev',
      children: /*#__PURE__*/_jsxs("ul", {
        className: "jsx-1685798257",
        children: [renderPrev(), /*#__PURE__*/_jsxs("li", {
          className: "jsx-1685798257",
          children: ["Page ", page, " of ", totalPages]
        }), renderNext()]
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1685798257",
      children: [".pagination-numbers.jsx-1685798257{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}", "@media(max-width:575px){.pagination-numbers.jsx-1685798257{display:none;}}", "@media(min-width:576px){.pagination-next-prev.jsx-1685798257{display:none;}}", ".pagination-next-prev.jsx-1685798257 ul{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;}", "p.jsx-1685798257{margin:0 20px 0 0;}", "ul.jsx-1685798257{list-style:none;margin:0;padding:0;display:grid;grid-auto-flow:column;grid-gap:5px;font-size:1.125rem;}", "ul.jsx-1685798257 a{display:block;padding:3px 7px;-webkit-text-decoration:none;text-decoration:none;}", "ul.jsx-1685798257 .is-current a{pointer-events:none;border-radius:3px;background:#FFDD15;}"]
    })]
  });
}